import React from 'react';
import RcCheckbox from 'rc-checkbox';
import { CheckboxProps } from './types';
import './index.less';

const Checkbox = ({ className = '', size, ...rest }: CheckboxProps) => {
  return (
    <span className={`checkbox-wrap ${className}`}>
      <RcCheckbox prefixCls="LdsCheckbox" type="checkbox" {...rest} />
    </span>
  );
};

export default Checkbox;
